const ASSETS_PATH = '/assets';

const join = (...parts: string[]) => parts.join('/').replace(/([^:]\/)\/+/g, '$1');

export const createAssetPathResolver =
    (localHost = '') =>
    (relativePath?: string): string | undefined => {
        if (!relativePath) return undefined;
        if (relativePath.startsWith('http')) return relativePath;

        const base = import.meta.env.VITE_ENV === 'local' ? join(localHost, ASSETS_PATH) : ASSETS_PATH;

        return join(base, relativePath);
    };
